import { MARKET_SLUGS } from '../market/slugs';
import type { TMarket, TMarketSlug } from '../market/types';

const FABRIC_LIS_RELEASED_MARKETS = new Set<TMarketSlug>([
    MARKET_SLUGS.IE,
    MARKET_SLUGS.FI,
    MARKET_SLUGS.EN,
    MARKET_SLUGS.ROG,
    MARKET_SLUGS.ROW,
    MARKET_SLUGS.EN_NZ,
    MARKET_SLUGS.EN_GB,
    MARKET_SLUGS.ES,
    MARKET_SLUGS.ON,
    MARKET_SLUGS.EN_CA
]);

export function isFabricLISReleased(market: TMarket): boolean {
    return FABRIC_LIS_RELEASED_MARKETS.has(market.slug);
}
